function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("title", null, "drawer-arrow");

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  fill: "#e6e6e6",
  points: "6.11 10.35 12.21 2.53 0 2.53 6.11 10.35"
}), /*#__PURE__*/React.createElement("rect", {
  fill: "#e6e6e6",
  width: 12.31,
  height: 1.2
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.31,
    height: 10.34,
    viewBox: "0 0 12.31 10.34"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/drawer-arrow.6d970077.svg";
export { SvgComponent as ReactComponent };